<template>
  <div class="page flex noselect">
    <div class="left">
      <div class="title">水务统计</div>
      <div class="flex justb" style="margin-bottom: 5%">
        <div class="tj1">
          <div class="text1">3,426.83</div>
          <div class="text2">灌溉区总面积</div>
          <div class="text2">(亩)</div>
        </div>
        <div class="tj2">
          <div class="text1">4</div>
          <div class="text2">灌区总数</div>
          <div class="text2">(个)</div>
        </div>
        <div class="tj3">
          <div class="text1">629</div>
          <div class="text2">检测点位总数</div>
          <div class="text2">(个)</div>
        </div>
        <div class="tj4">
          <div class="text1">1</div>
          <div class="text2">蓄水池</div>
          <div class="text2">(座)</div>
        </div>
      </div>
      <div class="title">水务分布</div>
      <leftCenterVue></leftCenterVue>
      <div class="flex justb" style="margin-top: 5%">
        <div class="title">灌区概况</div>
        <div class="dropcheck">
          <el-dropdown @command="handleDropdownChange">
            <el-button class="check-button">
              {{ waterName ? waterName : "选择" }} <i class="el-icon-caret-bottom"></i>
              <!-- <i class="el-icon-arrow-down el-icon--right"></i> -->
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <!-- <el-dropdown-item command="氮">水肥区1</el-dropdown-item>
              <el-dropdown-item command="磷">水肥区2</el-dropdown-item>
              <el-dropdown-item command="钾">水肥区3</el-dropdown-item>
              <el-dropdown-item command="EC">水肥区4</el-dropdown-item> -->
              <el-dropdown-item
                v-for="item in rightBottomSelectList"
                :key="item.id"
                :command="item.id"
              >
                {{ item.cropName }}
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
      <div class="flexCol alit justc">
        <div class="flex justb" style="width: 70%; margin: 10% 0">
          <div class="gq-info1">
            <div class="gq-text1">面积(亩)</div>
            <div class="gq-text2">{{ rightBottomData.cropArea }}</div>
          </div>
          <div class="gq-info2">
            <div class="gq-text1">水阀(个)</div>
            <div class="gq-text2">{{ rightBottomData.valveNum }}</div>
          </div>
        </div>
        <div class="flex justb" style="width: 70%">
          <div class="gq-info3">
            <div class="gq-text1">地块(块)</div>
            <div class="gq-text2">{{ rightBottomData.plotNum }}</div>
          </div>
          <div class="gq-info4">
            <div class="gq-text1">农户(户)</div>
            <div class="gq-text2">{{ rightBottomData.farmersNum }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="right">
      <div class="flex justb mjgg">
        <div class="flexCol alit" v-for="item in rightTopList">
          <img class="gg-img" :src="item.img" alt="" />
          <div class="gg-number">{{ rightTopDataList[item.key] }}</div>
          <img
            class="gg-dt"
            src="https://ica.obs.cn-south-1.myhuaweicloud.com/screen/%E6%99%BA%E6%85%A7%E6%B0%B4%E5%8A%A1/%E7%81%8C%E6%BA%89%E9%87%8F%E5%BA%95%E5%9B%BE%402x.png"
            alt=""
          />
          <div class="gg-title">{{ item.title }}</div>
        </div>
        <div class="jieduan">{{ rightTopDataList.currentStage }}</div>
      </div>
      <div class="right-content">
        <div class="flex">
          <div
            :class="
              contTitleIndex == 1 ? 'cont-title-check' : 'cont-title-default'
            "
            @click="contTitleIndex = 1"
          >
            按需灌水
          </div>
          <div
            :class="
              contTitleIndex == 2 ? 'cont-title-check' : 'cont-title-default'
            "
            @click="contTitleIndex = 2"
          >
            灌溉效率
          </div>
          <div
            :class="
              contTitleIndex == 3 ? 'cont-title-check' : 'cont-title-default'
            "
            @click="contTitleIndex = 3"
          >
            AI需水预测
          </div>
          <div
            :class="
              contTitleIndex == 4 ? 'cont-title-check' : 'cont-title-default'
            "
            @click="contTitleIndex = 4"
          >
            托管设置
          </div>
        </div>
        <div class="">
          <!-- 灌溉效率 -->
          <waterOnDemand
            :waterId="waterId"
            v-if="contTitleIndex == 2"
          ></waterOnDemand>
          <!-- AI预测 -->
          <irrigationEfficiency
            :waterId="waterId"
            v-if="contTitleIndex == 3"
          ></irrigationEfficiency>
          <!-- 按需灌水 -->
          <AIPrediction
            :waterId="waterId"
            v-if="contTitleIndex == 1"
            :needWaterData="needWaterData"
          ></AIPrediction>
          <!-- 托管设置 -->
          <hostingSettings v-if="contTitleIndex == 4"></hostingSettings>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import leftCenterVue from "./leftCenter.vue";
import waterOnDemand from "./waterOnDemand.vue"; //按需灌水
import irrigationEfficiency from "./irrigationEfficiency.vue"; //灌溉效率
import AIPrediction from "./AIPrediction.vue"; //AI预测
import hostingSettings from "./hostingSettings.vue"; //托管设置
import { create } from "lodash";
export default {
  components: {
    leftCenterVue,
    waterOnDemand,
    irrigationEfficiency,
    AIPrediction,
    hostingSettings,
  },
  data() {
    return {
      contTitleIndex: 1,
      rightTopList: [
        {
          img: "https://ica.obs.cn-south-1.myhuaweicloud.com/screen/%E6%99%BA%E6%85%A7%E6%B0%B4%E5%8A%A1/%E4%BB%8A%E6%97%A5%E7%94%A8%E6%B0%B4%E9%87%8F%402x.png",
          title: "今日用水量(m³)",
          number: "4,096",
          key: "todayUseSum",
        },
        {
          img: "https://ica.obs.cn-south-1.myhuaweicloud.com/screen/%E6%99%BA%E6%85%A7%E6%B0%B4%E5%8A%A1/%E4%BB%8A%E6%97%A5%E4%BA%A9%E5%9D%87%E7%94%A8%E6%B0%B4%E9%87%8F%402x.png",
          title: "今日亩均用水量(m³)",
          number: "126",
          key: "todayUseEqual",
        },
        {
          img: "https://ica.obs.cn-south-1.myhuaweicloud.com/screen/%E6%99%BA%E6%85%A7%E6%B0%B4%E5%8A%A1/%E5%B9%B4%E7%81%8C%E6%BA%89%E9%87%8F%402x.png",
          title: "年灌溉量(m³)",
          number: "56,871",
          key: "yearUseSum",
        },
        {
          img: "https://ica.obs.cn-south-1.myhuaweicloud.com/screen/%E6%99%BA%E6%85%A7%E6%B0%B4%E5%8A%A1/%E5%B9%B4%E7%81%8C%E4%BA%A9%E5%9D%87%E6%BA%89%E9%87%8F%402x.png",
          title: "年亩均灌溉量(m³)",
          number: "3,216",
          key: "yearUseEqual",
        },
        {
          img: "https://ica.obs.cn-south-1.myhuaweicloud.com/screen/%E6%99%BA%E6%85%A7%E6%B0%B4%E5%8A%A1/%E5%8E%BB%E5%B9%B4%E7%81%8C%E6%BA%89%E9%87%8F%402x.png",
          title: "去年灌溉量(m³)",
          number: "13,411",
          key: "lastUseSum",
        },
        {
          img: "https://ica.obs.cn-south-1.myhuaweicloud.com/screen/%E6%99%BA%E6%85%A7%E6%B0%B4%E5%8A%A1/%E5%8E%BB%E5%B9%B4%E4%BA%A9%E5%9D%87%E7%81%8C%E6%BA%89%E9%87%8F%402x.png",
          title: "去年亩均灌溉量(m³)",
          number: "3,411",
          key: "lastUseEqual",
        },
      ],
      rightTopDataList: [],
      rightBottomSelectList: [
        {
          id: 1,
          cropName: "水肥区1",
        },
        {
          id: 2,
          cropName: "水肥区2",
        },
        {
          id: 3,
          cropName: "水肥区3",
        },
        {
          id: 4,
          cropName: "水肥区4",
        },
      ],
      rightBottomData: {},
      needWaterData: {},
      waterId: 1,
      waterName: "水肥区1",
    };
  },
  methods: {
    handleDropdownChange(id) {
      this.waterId = id;
      this.waterName = this.rightBottomSelectList[id - 1].cropName;
      //获取水肥区统计信息
      this.$request("iot/screen/plot/getCrop?id=" + id).then((res) => {
        this.rightBottomData = res.data;
      });
      //获取灌区信息
      this.$request("iot/screen/water/getRegion?id=" + id).then((res) => {
        this.rightTopDataList = res.data;
        //获取按需灌水土壤信息
        this.$request("iot/screen/water/getNeed?id=" + id).then((res) => {
          this.needWaterData = res.data;
          this.needWaterData.nextDate = this.rightTopDataList.nextDate;
          this.needWaterData.nextWater = this.rightTopDataList.nextWater;
          this.needWaterData.sumWater = this.rightTopDataList.sumWater;
        });
      });
    },
  },
  mounted() {
    this.handleDropdownChange(1);
  },
};
</script>

<style lang="scss" scoped>
.right {
  width: 1320px;
  margin-top: 11vh;
  position: relative;
  z-index: 999;
  .jieduan {
    margin-top: 40px;
    width: 158px;
    height: 100px;
    background-image: url("https://ica.obs.cn-south-1.myhuaweicloud.com/screen/%E6%99%BA%E6%85%A7%E6%B0%B4%E5%8A%A1/%E9%98%B6%E6%AE%B5%402x.png");
    background-size: 100% 100%;

    font-family: zihun148hao, zihun148hao;
    font-weight: 900;
    font-size: 23px;
    color: #fff9f9;
    line-height: 100px;
    letter-spacing: 1px;
    text-shadow: -1px 21px 4px rgba(27, 85, 139, 0.88);
    text-align: center;
  }
  .right-content {
    width: 1240px;
    height: 660px;
    background-image: url("https://ica.obs.cn-south-1.myhuaweicloud.com/screen/%E6%99%BA%E6%85%A7%E6%B0%B4%E5%8A%A1/%E5%86%85%E5%AE%B9%E8%83%8C%E6%99%AF%402x.png");
    background-size: 100% 100%;
    padding: 40px;

    .cont-title-check {
      width: 110px;
      height: 36px;
      background-image: url("https://ica.obs.cn-south-1.myhuaweicloud.com/screen/%E6%99%BA%E6%85%A7%E6%B0%B4%E5%8A%A1/%E5%8F%B3%E5%9B%BE%E6%A0%87%E6%A0%87%E9%A2%98%E8%83%8C%E6%99%AF%E9%80%89%E4%B8%AD%402x.png");
      background-size: 100% 100%;

      font-family: YouSheBiaoTiHei;
      font-size: 18px;
      color: #ffffff;
      line-height: 36px;
      letter-spacing: 1px;
      text-align: center;
      margin-left: 15px;
    }
    .cont-title-default {
      width: 110px;
      height: 36px;
      background-image: url("https://ica.obs.cn-south-1.myhuaweicloud.com/screen/%E6%99%BA%E6%85%A7%E6%B0%B4%E5%8A%A1/%E5%8F%B3%E5%9B%BE%E6%A0%87%E6%A0%87%E9%A2%98%E8%83%8C%E6%99%AF%E6%9C%AA%E9%80%89%E4%B8%AD%402x.png");
      background-size: 100% 100%;

      font-family: YouSheBiaoTiHei;
      font-size: 18px;
      color: #ffffff;
      line-height: 36px;
      letter-spacing: 1px;
      text-align: center;
      margin-left: 15px;
      cursor: pointer;
    }
  }
  .mjgg {
    width: 95%;
    margin-left: 20px;
    .gg-img {
      width: 80px;
      height: 70px;
    }
    .gg-dt {
      width: 95px;
      height: 16px;
      margin-top: -16px;
    }
    .gg-number {
      font-family: DIN-BoldItalic, DIN-BoldItalic;
      font-weight: 900;
      font-size: 34px;
      background: linear-gradient(180deg, #fff600 50%, #fffca2 50%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      font-style: italic;
      padding-right: 5px;
    }
    .gg-title {
      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 16px;
      color: #44c1ef;
      text-shadow: 2px 2px 5px rgba(17, 20, 22, 0.22);
      text-align: center;
      font-style: normal;
      text-transform: none;
    }
  }
}
.left {
  width: 420px;
  position: relative;
  z-index: 999;
  margin: 10vh 20px 0 30px;
  .gq-info1 {
    width: 117px;
    height: 53px;
    background-image: url("https://ica.obs.cn-south-1.myhuaweicloud.com/screen/%E6%99%BA%E6%85%A7%E6%B0%B4%E5%8A%A1/%E7%81%8C%E5%8C%BA%E9%9D%A2%E7%A7%AF%402x.png");
    background-size: 100% 100%;
  }
  .gq-info2 {
    width: 117px;
    height: 53px;
    background-image: url("https://ica.obs.cn-south-1.myhuaweicloud.com/screen/%E6%99%BA%E6%85%A7%E6%B0%B4%E5%8A%A1/%E7%81%8C%E5%8C%BA%E6%B0%B4%E9%98%80%402x.png");
    background-size: 100% 100%;
  }
  .gq-info3 {
    width: 117px;
    height: 53px;
    background-image: url("https://ica.obs.cn-south-1.myhuaweicloud.com/screen/%E6%99%BA%E6%85%A7%E6%B0%B4%E5%8A%A1/%E7%81%8C%E5%8C%BA%E5%9C%B0%E5%9D%97%402x.png");
    background-size: 100% 100%;
  }
  .gq-info4 {
    width: 117px;
    height: 53px;
    background-image: url("https://ica.obs.cn-south-1.myhuaweicloud.com/screen/%E6%99%BA%E6%85%A7%E6%B0%B4%E5%8A%A1/%E7%81%8C%E5%8C%BA%E5%86%9C%E6%88%B7%402x.png");
    background-size: 100% 100%;
  }
  .gq-text1 {
    font-weight: 400;
    font-size: 14px;
    color: #ffffff;
    font-style: italic;
    margin-left: 60px;
  }
  .gq-text2 {
    font-family: JiangChengXieHei, JiangChengXieHei;
    font-weight: 900;
    font-size: 19px;
    color: #ffffff;
    text-shadow: 2px 2px 4px rgba(49, 50, 51, 0.22),
      0px 0px 10px rgba(73, 223, 255, 0.48);
    text-transform: none;
    background: linear-gradient(3.8059132373276543deg, #389dff 0%, #ffffff 85%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    font-style: italic;
    margin-left: 60px;
    width: 90px;
  }
  .dropcheck {
    position: relative;
    z-index: 99;
  }
  .check-button {
    background-image: url("https://ica.obs.cn-south-1.myhuaweicloud.com/screen/gif/%E9%80%89%E6%8B%A9%402x.png") !important;
    background-size: 100% 100%;
    background-repeat: no-repeat !important;
    background-position-x: 4px !important;
    background-position-y: 2px !important;
    color: #ffffff !important;
    width: 103px;
    height: 44px;
    // letter-spacing: 3px;
  }
  .tj1 {
    width: 100px;
    height: 192px;
    background-image: url("https://ica.obs.cn-south-1.myhuaweicloud.com/screen/%E6%99%BA%E6%85%A7%E6%B0%B4%E5%8A%A1/%E7%BB%9F%E8%AE%A11%402x.png");
    background-size: 100% 100%;
  }
  .tj2 {
    width: 100px;
    height: 192px;
    background-image: url("https://ica.obs.cn-south-1.myhuaweicloud.com/screen/%E6%99%BA%E6%85%A7%E6%B0%B4%E5%8A%A1/%E7%BB%9F%E8%AE%A12%402x.png");
    background-size: 100% 100%;
  }
  .tj3 {
    width: 100px;
    height: 192px;
    background-image: url("https://ica.obs.cn-south-1.myhuaweicloud.com/screen/%E6%99%BA%E6%85%A7%E6%B0%B4%E5%8A%A1/%E7%BB%9F%E8%AE%A13%402x.png");
    background-size: 100% 100%;
  }
  .tj4 {
    width: 100px;
    height: 192px;
    background-image: url("https://ica.obs.cn-south-1.myhuaweicloud.com/screen/%E6%99%BA%E6%85%A7%E6%B0%B4%E5%8A%A1/%E7%BB%9F%E8%AE%A14%402x.png");
    background-size: 100% 100%;
  }
  .text1 {
    font-weight: bold;
    font-size: 20px;
    color: #ffffff;
    text-shadow: 0px 2px 6px rgba(0, 0, 0, 0.2);
    text-align: center;
    margin-top: 118px;
    margin-bottom: 5px;
  }
  .text2 {
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 12px;
    color: #47b2ff;
    text-align: center;
  }
}
.page {
  width: 100vw;
  height: 100vh;
  background-image: url("https://ica.obs.cn-south-1.myhuaweicloud.com/screen/fourEmotions/%E5%9B%9B%E6%83%85%E8%83%8C%E6%99%AF%402x.png");
  background-size: 100% 100%;
  overflow: hidden;
}
</style>
